
<template>
  <div>
    <el-form class="details-line-height details-line-height-padding">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label-width="0">
            <span class="details-title">{{"合同概述："}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同编号：">{{params.purchaseContractBasesVo.pcbNumber}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商：">{{params.purchaseContractBasesVo.suName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商合同编号：">{{params.purchaseContractBasesVo.supplierContractNumber}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="合同金额："
          >{{params.purchaseContractBasesVo.purchaseTotal|priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已付账款：">{{params.purchaseContractBasesVo.actualTotal|priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="应付账款："
          >{{params.purchaseContractBasesVo.accountsPayable | priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="已到期账款："
          >{{params.purchaseContractBasesVo.accountsDue| priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="未到期账款："
          >{{params.purchaseContractBasesVo.accountsOutstanding| priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="合同状态："
          >{{contactList[params.purchaseContractBasesVo.contractState-1]}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签订时间：">{{params.purchaseContractBasesVo.signTime|dateFilter}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form class="details-line-height-padding-sec">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="退货商品价值：">{{params.retreatTotal| priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="罚没金额：">{{params.confiscatedTotal| priceFilterNum}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="罚没比例：">{{params.confiscatedRadio|perCentFilterL}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  components: {
  },

  props: ['params'],
  data () {
    return {
      contactList: ['待审核', '审核中', '履行中', '已履行', '待签署', '已作废', '合同审核不通过', '盖章审核驳回', '盖章审核']

    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.details-line-height-padding {
  padding: 20px 30px 0 30px;
}
.details-title {
  font-weight: 600;
  font-size: 16px;
}
.details-line-height-padding-sec {
  padding: 10px 30px 0 30px;
}
</style>
